/**
 * @generated SignedSource<<7d02b59f3e7bd70497ed53599086ff39>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProfileDisplayType = "BASIC" | "BLOG" | "RESOURCE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProfileProjects_userProfile$data = {
  readonly displayUsername: string;
  readonly firstName: string | null;
  readonly id: string;
  readonly portfolioProjects: {
    readonly count: number;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly author: {
          readonly id: string;
        } | null;
        readonly blogCategories: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
            };
          }>;
        } | null;
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"BlogCard_portfolioProject" | "ProjectCardV2DataWrapper_portfolioProject">;
      };
    }>;
  };
  readonly profileDisplayType: ProfileDisplayType;
  readonly visitorCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"BlogCard_userProfile" | "ProjectCardV2DataWrapper_userProfile">;
  readonly " $fragmentType": "ProfileProjects_userProfile";
};
export type ProfileProjects_userProfile$key = {
  readonly " $data"?: ProfileProjects_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileProjects_userProfile">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileProjects_userProfile",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileDisplayType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUsername",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "ALL"
        }
      ],
      "concreteType": "UserProfilePortfolioProjectConnection",
      "kind": "LinkedField",
      "name": "portfolioProjects",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UserProfilePortfolioProjectEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PortfolioProject",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "UserProfile",
                  "kind": "LinkedField",
                  "name": "author",
                  "plural": false,
                  "selections": (v1/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "BlogCategoryConnection",
                  "kind": "LinkedField",
                  "name": "blogCategories",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "BlogCategoryEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "BlogCategory",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": (v1/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ProjectCardV2DataWrapper_portfolioProject"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "BlogCard_portfolioProject"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "portfolioProjects(type:\"ALL\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProjectCardV2DataWrapper_userProfile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BlogCard_userProfile"
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};
})();

(node as any).hash = "7ffefbc2a3abccacb2ba080de183dd95";

export default node;
